import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { message } from "antd";

import { IoIosInformationCircleOutline } from "react-icons/io";

import { QuestionnaireAction } from "../../store/actions";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
  inputFields,
  Loader,
  popover,
} from "../../components";

import { UtilityArrays, Utils } from "../../config";

import "./styles.css";

const Education = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const profileData = useSelector((state) => state.profile?.user);

  const { questionnaire, isLoading } = useSelector(
    (state) => state?.questionnaire
  );

  const [state, setState] = useState({
    expectedGradYear: null,
    curriculum: null,
  });

  useEffect(() => {
    dispatch(QuestionnaireAction.getQuestionnaire());
  }, []);

  useEffect(() => {
    setState({
      expectedGradYear: questionnaire?.expectedGradYear ?? null,
      curriculum: questionnaire?.curriculum ?? null,
    });
  }, [questionnaire]);

  const handleNext = () => {
    if (!state.curriculum) {
      message.error("Please fill all the fields.");
    } else {
      const payload = { userId: profileData?.id, ...state };

      dispatch(
        QuestionnaireAction.addQuestionnaire(payload, (res) => {
          if (res.status === 200) {
            dispatch(
              QuestionnaireAction.getQuestionnaire(() =>
                navigate("/profile-builder/high-school-grades")
              )
            );
          }
        })
      );
    }
  };

  return (
    <div className="text-black">
      <div className="header-md pl-2 flex gap-2 items-center">Education</div>
      <Spacer height={10} />
      {isLoading ? (
        <Loader.Circular />
      ) : (
        <boxContainer.LiteBoxContainer>
          <div className="grid grid-cols-2 gap-x-7 gap-y-6">
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="Current School"
                required
              />
              <Spacer height={5} />
              <inputFields.DefaultInput
                placeholder="Dubai School"
                value={
                  profileData?.schoolName ??
                  `${profileData?.student?.school?.userId?.firstName} ${profileData?.student?.school?.userId?.lastName}`
                }
                disabled
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel
                text="Current Grade"
                required
              />
              <Spacer height={5} />
              <inputFields.DefaultInput
                placeholder="grade"
                value={profileData?.student?.grade}
                disabled
              />
            </div>
            <div>
              <questionnaireComponents.QuestionnaireLabel text="Expected Graduation Year" />
              <Spacer height={5} />
              <inputFields.SelectDropdown
                onChange={(e) => setState({ ...state, expectedGradYear: e })}
                items={Utils.filterArray(UtilityArrays.gradYearsArray)}
                placeholder="Select your graduation year"
                value={state?.expectedGradYear}
              />
            </div>
            <div>
              <div className="flex gap-2 items-center">
                <questionnaireComponents.QuestionnaireLabel
                  text="Curriculum"
                  required
                />
                <span>
                  <popover.WhitePopover
                    content={
                      <div className="text-[14px] font-medium">
                        Please specify the current <br /> education
                        qualification
                        <br />
                        that you are pursuing
                      </div>
                    }
                    trigger="hover"
                    placement="right"
                  >
                    <IoIosInformationCircleOutline className="text-main" />
                  </popover.WhitePopover>
                </span>
              </div>
              <Spacer height={5} />
              <inputFields.SelectDropdown
                onChange={(e) => setState({ ...state, curriculum: e })}
                items={Utils.filterArray(UtilityArrays.curriculum)}
                placeholder="Select your curriculum"
                value={state?.curriculum}
              />
            </div>
          </div>
          <Spacer height={20} />
          <div className="flex justify-end">
            <div className="w-[12.5em]">
              <Buttons.DefaultButton
                onClick={handleNext}
                size="large"
                width="full"
              >
                Next
              </Buttons.DefaultButton>
            </div>
          </div>
        </boxContainer.LiteBoxContainer>
      )}
    </div>
  );
};

export default Education;
